/* eslint-disable */
import { TaskState } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const getters = {
    taskList: (state: TaskState) => state.taskList,
    TaskStatus: (state: TaskState) => state.TaskStatus,
    TaskStats: (state: TaskState) => state.TaskStats,
    PerformanceVersions: (state: TaskState) => state.PerformanceVersions,
    accountList: (state: TaskState) => state.accountList,
    TestData: (state: TaskState) => state.TestData,
    taskRecords: (state: TaskState) => state.taskRecords,
    taskSimpleRecords: (state: TaskState) => state.taskSimpleRecords,
    taskRecord: (state: TaskState) => state.taskRecord,
    taskGroup: (state: TaskState) => {
      return state.taskGroup;
    },
    scriptList: (state: TaskState) => state.scriptList,
    recordProject: (state: TaskState) => state.recordProject,
    simpleScriptList: (state: TaskState) => state.simpleScriptList,
    pipelineList: (state: TaskState) => state.pipelineList,
    pipelinePkgList: (state: TaskState) => state.pipelinePkgList,
    pipelineCheck: (state: TaskState) => state.pipe_line,
};

const {read} = getStoreAccessors<TaskState, State>('');

export const readTaskList = read(getters.taskList);
export const readTaskStatus = read(getters.TaskStatus);
export const readTaskStats = read(getters.TaskStats);
export const readTaskPerformanceVersions = read(getters.PerformanceVersions);
export const readTest = read(getters.TestData);
export const readTaskRecords = read(getters.taskRecords);
export const readTaskSimpleRecords = read(getters.taskSimpleRecords);
export const readTaskRecord = read(getters.taskRecord);
export const readScriptList = read(getters.scriptList);
export const readSimpleScriptList = read(getters.simpleScriptList);
export const readTaskGroup = read(getters.taskGroup);
export const readAccountList = read(getters.accountList);
export const readPipelineList = read(getters.pipelineList);
export const readPipelinePkgList = read(getters.pipelinePkgList);
export const readRecordProject = read(getters.recordProject);
export const readPipelineCheck = read(getters.pipelineCheck);


